import React, { useState } from 'react';
import snow from '../../../assets/svg/snow.svg';
import sun from '../../../assets/svg/sun.svg';
import ButtonSec from '../../../components/Buttons/ButtonSecundary';
import { useScreenSize } from '../../../hooks/useScreenSize';
import CustomDropdown from '../../../components/Buttons/Dropdown';

const Intro: React.FC = () => {
  const { isMobile, isTablet } = useScreenSize();
  const [selectedAirco, setSelectedAirco] = useState<string>('');

  const aircoOptions = [
    'split airco',
    'multi-split airco',
    'monoblock airco',
    'cassette airco',
    'kanaal airco',
    'vloerconsole airco',
    'plafond airco',
  ];

  return (
    <header className="header-container header-container-sec ">
      <div className="slide flex-colomn gap-2">
        <div className="flex-colomn">
          <h1>
            <span className="tertiary-color">Airco </span>solutions!
          </h1>

          <p className="slide-text">
            Onze <span className="bold">installaties</span> zorgen voor een{' '}
            <span className="bold">perfect klimaat</span> in elke ruimte — van frisse verkoeling op
            warme dagen tot aangename warmte in de winter.
          </p>
        </div>

        <div className={`${isTablet ? 'flex-colomn' : 'flex-row'} w-100 gap-2`}>
          <div className={`${isMobile ? 'flex-colomn gap-2' : 'flex-row'}`}>
            <CustomDropdown
              className={`${isMobile ? 'w-100' : ''}`}
              options={aircoOptions}
              value={selectedAirco}
              onChange={setSelectedAirco}
              textInput="Kies uw airco type"
            />
            <ButtonSec text="Download Catalogus" />
          </div>

          <div className="flex-row">
            <img className="icon" src={snow} alt="sneeuwvlok" />
            <img className="icon" src={sun} alt="zon" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Intro;
